import { Helmet } from 'react-helmet';

// компонент для 404
const NotFound = () => (
  <>
    <Helmet>
      <title>404</title>
    </Helmet>
    <h1>NotFound</h1>
  </>
);

export default NotFound;
